// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8ec5d062","453":"398a2d32","455":"b463fb73"}[chunkId] + ".chunk.js";
};